import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/video/si-portfolio.mp4")